import _ from 'lodash'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import isEqual from 'react-fast-compare'

const useEmployeeBookings = ( guid, selectedLocationDate ) => {
	return useSelector( state => {
		if( guid === null || selectedLocationDate === null ) return null;

		return _.find(
			_.get( state.data[ dataConstants.EMPLOYEES_BOOKINGS ], selectedLocationDate, {} ),
			{ guid: guid }
		) ?? null;
	}, isEqual );
}

export default useEmployeeBookings
